import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '@/components/Layout';
import SchoolLayout from '@/components/Layout/schoolLayout'

Vue.use(VueRouter);

const routes = [
  //首页
  {
    path: '/',
    name: 'HomeIndex',
    redirect: '/home',
    component: Layout,
    children: [{
      path: 'home',
      name: 'Home',
      component: () => import('@/views/Home')
    }]
  },
  //学校首页
  {
    path: '/school',
    name: 'SchoolMoudle',
    redirect: '/school/:id',
    component: SchoolLayout,
    children: [{
      path: ':id',
      name: 'School',
      component: () => import('@/views/School')
    }]
  },
  //课程列表&&课程详情
  {
    path: '/course',
    name: 'Course',
    redirect: '/course/:id',
    component: SchoolLayout,
    children: [{
      path: ':id',
      name: 'CourseList',
      component: () => import('@/views/Course/index')
    }]
  },
  {
    path: '/detail',
    name: 'CourseDetail',
    redirect: '/course/detail',
    component: Layout,
    children: [{
      path: '/detail',
      name: 'Detail',
      component: () => import('@/views/Course/detail')
    }]
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;